import { render, staticRenderFns } from "./waitPrinted.vue?vue&type=template&id=85389e20&scoped=true"
import script from "./waitPrinted.vue?vue&type=script&lang=js"
export * from "./waitPrinted.vue?vue&type=script&lang=js"
import style0 from "./waitPrinted.vue?vue&type=style&index=0&id=85389e20&prod&lang=stylus&scoped=true"
import style1 from "./waitPrinted.vue?vue&type=style&index=1&id=85389e20&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85389e20",
  null
  
)

export default component.exports